const actionTypeIdentifier = 'F910B160-11D0-4C88-8D6E-4E58240BBA48'; // to generate open ssms run select newid()

//location form actions
export const setCountryOptions = `SET-NEW-MOBILE-COUNTRY-OPTIONS-${actionTypeIdentifier}`;
export const setAddressOptions = `SET-NEW-MOBILE-ADDRESS-OPTIONS-${actionTypeIdentifier}`;
export const setUserLocation = `SET-NEW-MOBILE-USER-LOCATION-${actionTypeIdentifier}`;
//subscription form actions
export const setPlanOptions = `SET-NEW-MOBILE-PLANS-OPTIONS-${actionTypeIdentifier}`;
export const setSimOptions = `SET-NEW-MOBILE-SIM-OPTIONS-${actionTypeIdentifier}`;
export const setVendorOptions = `SET-NEW-MOBILE-VENDOR-OPTIONS-${actionTypeIdentifier}`;
export const setOrderOptions = `SET-NEW-MOBILE-ORDER-OPTIONS-${actionTypeIdentifier}`;
export const setCircuitTypes = `SET-NEW-MOBILE-CIRCUIT-TYPES-OPTIONS-${actionTypeIdentifier}`;
export const setDeviceOptions = `SET-NEW-MOBILE-DEVICE-OPTIONS-${actionTypeIdentifier}`;
export const setDeviceAccessories = `SET-NEW-MOBILE-DEVICE-ACCESSORIES-${actionTypeIdentifier}`;
export const setVendorDetails = `SET-NEW-MOBILE-VENDOR-DETAILS-${actionTypeIdentifier}`;
export const setPrimaryPlanDetails = `SET-NEW-MOBILE-PRIMARY-PLAN-DETAILS-${actionTypeIdentifier}`;
export const setServiceTypeDetails = `SET-NEW-MOBILE-SERVICE-TYPE-DETAILS-${actionTypeIdentifier}`;
//business form actions
export const setPurposeOfUseOptions = `SET-NEW-MOBILE-PURPOSE-OF-USE-OPTIONS-${actionTypeIdentifier}`;
export const setBusinessCaseOptions = `SET-NEW-MOBILE-BUSINESS-CASE-OPTIONS-${actionTypeIdentifier}`;
export const setShowDeviceOptions = `SET-NEW-MOBILE-SHOW-DEVICE-OPTIONS-${actionTypeIdentifier}`;
export const setShowOtherAddress = `SET-NEW-MOBILE-SHOW-OTHER-ADDRESS-${actionTypeIdentifier}`;
export const setFormSubmitted = `SET-NEW-MOBILE-FORM-SUBMITTED-${actionTypeIdentifier}`;
export const setEmployeeEquipmentProductNames = `SET-EMPLOYEE-EQUIPMENT-PRODUCT-NAME-${actionTypeIdentifier}`;
export const setEmployeeEquipmentOnprogressProductNames = `SET-EMPLOYEE-EQUIPMENT-ON-PROGRESS-PRODUCT-NAME-${actionTypeIdentifier}`;

export const locationModelA = {
    countryCode: 'US'
    , country: ''
    , locationId: ''
    , otherDeliveryAddress: ''
    , deliveryAddress: ''
}

export const subscriptionModelA = {
    vendorDetailId: ''
    , orderOptionId: 0
    , equipmentCatalogId: 0
    , accessoryDetailsModel: []
    , planId: 0
    //, simTypeId: 0
    , mobileServiceModel: []
    , planDetails: {
        planComponents: []
    }
    , planDetailsModel: []
    , circuitTypeModel: []
    , phoneCaseAccessory: false
    , mobileDetailsModel: []
}

export const businessModelA = {
    purposeOfUseId: 0
    , busJustiCodeDetailId: 0
    , busJustiCodeDetailTextValue: ''
    , businessJustification: ''
    , additionalInformation: ''
    , termAgreement: false
}